module.exports = __webpack_public_path__ + "img/Checkbox-On_16px_Icon_dark.c22b63b7.svg";